import maplibregl from 'maplibre-gl';
// CRA already supplies file-loader. Bypass its Babel loaders for this asset.
// eslint-disable-next-line import/no-webpack-loader-syntax
import workerUrl from '!!file-loader!maplibre-gl/dist/maplibre-gl-csp-worker.js';

// Emit the packaged worker as a separate asset without Babel: the main bundle's
// optimizer can move bindings outside an inline worker and break tile decoding.
export function configureListingMapWorker() {
  maplibregl.setWorkerUrl(workerUrl);
}
